import React from 'react';
import { compose } from 'redux';
import { BasePage } from 'altus-ui-components';
import withStyles from '@material-ui/styles/withStyles';
import {
  getCurrentClientOrganizationIdFromState,
  getSummarizedDataStateFromState,
} from 'app/app.selectors';
import { connect, useSelector } from 'react-redux';
import { getCurrentProject } from 'features/projects/projects.selectors';
import {
  getAllTasksFromState,
  getTaskTemplates,
} from 'features/projects/tasks/tasks.selectors';
import { useEffect } from 'react';
import { TASK_ACTIONS } from 'features/projects/tasks/tasks.constants';
import { getAllTasks } from 'features/projects/activities/activities.actions';
import { tasksContainerOnUnload } from 'features/projects/tasks/tasks.actions';
import { onLoad } from 'features/projects/details/details.actions';
import {
  getProjectResources,
  onLoad as onStatusLoad,
} from 'features/projects/projects.actions';
import ExecutionDetailsHeader from 'features/mobile/projects/execute/taskActivities/ExecutionDetailsHeader';
import MobileExecutionDetails from 'features/mobile/projects/execute/taskActivities/MobileExecutionDetails';

const MobileTaskDetailsContainer = ({
  projectId,
  taskId,
  tasks,
  classes,
  dataState,
  dispatchOnLoad,
  dispatchOnLoadStatus,
  dispatchGetProjectResources,
  dispatchOnUnload,
  dispatchGetTasks,
}) => {
  const currentTask = tasks
    ?.filter((task) => task.get('taskId') === Number(taskId))
    .first();
  const currentClientOrganizationId = useSelector(
    getCurrentClientOrganizationIdFromState,
  );
  useEffect(() => {
    dispatchOnLoad(projectId);
    dispatchGetTasks(projectId);
    dispatchOnLoadStatus(currentClientOrganizationId);
    dispatchGetProjectResources(projectId);

    return () => dispatchOnUnload();
  }, [
    projectId,
    dispatchGetTasks,
    dispatchOnLoad,
    dispatchOnUnload,
    dispatchOnLoadStatus,
    currentClientOrganizationId,
    dispatchGetProjectResources,
  ]);

  return (
    <BasePage
      dataState={dataState}
      classes={{
        children: classes.basePageChildren,
      }}
    >
      {currentTask && currentTask.size && (
        <>
          <ExecutionDetailsHeader projectId={projectId} task={currentTask} />
          <MobileExecutionDetails task={currentTask} projectId={projectId} />
        </>
      )}
    </BasePage>
  );
};

const styles = (theme) => ({
  basePageChildren: {
    padding: 0,
    background: theme.palette.secondary.dark,
    overflowX: 'hidden',
  },
  content: {
    padding: theme.spacing(2),
  },
});

const mapStateToProps = (state) => ({
  project: getCurrentProject(state),
  tasks: getAllTasksFromState(state),
  templateTasks: getTaskTemplates(state),
  dataState: getSummarizedDataStateFromState(state, TASK_ACTIONS.GET_ALL_TASKS),
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetTasks: (projectId) => dispatch(getAllTasks(projectId)),
    dispatchOnUnload: tasksContainerOnUnload,
    dispatchOnLoad: (projectId) => dispatch(onLoad(projectId)),
    dispatchOnLoadStatus: onStatusLoad,
    dispatchGetProjectResources: (projectId) =>
      dispatch(getProjectResources(projectId)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(MobileTaskDetailsContainer);
